import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import '@/components/globals/'

// Vue.config.productionTip = process.env.NODE_ENV === 'production'

import Default from '@/layouts/Default.vue';
import Login from '@/layouts/Login.vue';
import Empty from '@/layouts/Empty.vue';

Vue.component('empty-layout', Empty);
Vue.component('login-layout', Login);
Vue.component('default-layout', Default);

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#kvkk')
